import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UiService} from '../../services/ui-service/ui.service';
import {RoutingService} from '../../services/routing-service/routing.service';
import {ReservationFormComponent} from '../reservation-form/reservation-form.component';


@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.scss']
})
export class RightMenuComponent implements OnInit {

  @ViewChild (ReservationFormComponent) public reservationForm: ReservationFormComponent;




  private iconVisibility: boolean;

  toggleRightMenu = () => {
    // console.log('ds');
    document.getElementsByClassName('rmenu')[0].classList.toggle('open');
    document.getElementsByClassName('rmenu-inner')[0].classList.toggle('open');
    document.getElementsByClassName('rmenu-toggler')[0].classList.toggle('--hidden');
  }


  closeRightMenu = () => {
    document.getElementsByClassName('rmenu')[0].classList.remove('open');
    document.getElementsByClassName('rmenu-inner')[0].classList.remove('open');
    document.getElementsByClassName('rmenu-toggler')[0].classList.remove('--hidden');
  }

  openRightMenu = () => {
    document.getElementsByClassName('rmenu')[0].classList.add('open');
    document.getElementsByClassName('rmenu-inner')[0].classList.add('open');
    document.getElementsByClassName('rmenu-toggler')[0].classList.add('--hidden');
  }


  constructor(private UIservice: UiService, private routingService: RoutingService) {
    this.UIservice.listenRightMenuToggle().subscribe( () =>{
      this.toggleRightMenu();
    });

    this.UIservice.listenRightMenuClose().subscribe( () =>{
      this.closeRightMenu();
    });

    this.UIservice.listenRightMenuIconVisibility().subscribe((value => {
      this.iconVisibility = value;
    }));


    // this.routingService.listenToRouteChange().subscribe(price => {
    //   this.UIservice.toggleRightMenu(price);
    // });
  }

  ngOnInit() {

  }

}
